( function ( $ ) {
	$(document.body).on('added_to_cart wc_fragments_refreshed', function() {
		$('.mini-cart').fadeIn("slow", function() { $(this).delay(4000).fadeOut("slow"); });
	});
}( jQuery ) );